export enum ERoutes {
  testdev = "/test-devs",
  breedGroups = "/BreedGroups",
  breeds = "/breeds",
  color = "/color",
  country = "/country",
  home = "/home",
  kennel = "/kennel",
  workbookType = "/workbookType",
  dog = "/dog",
  dashboard = "/dashboard",
  section = "/section",
  activity = "/activity",
  calendarYear = "/calendarYear",
  subActivity = "/subActivity",
  club = "/Club",
  translations = "/translations",
  people = "/people",
  clubRoles = "/clubRoles",
  characteristics = "/characteristics",
  characteristicValues = "/CharacteristicValues",
  titleType = "/titleType",
  requests = "/requests",
  pedigreeDuplicata = "/pedigreeDuplicata",
  rsh = "/rshRequest",
  rish = "/rishRequest",
  titleRequests = "/titleRequests",
  clinic = "/clinic",
  workbookRequest = "/WorkbookRequest",
  workAttestationRequest = "/workAttestationRequest",
  tempRsh = "/tempRSHRequest",
  user = "/user",
  importRequest = "/importRequest",
  unauthorized = "/unauthorized",
  permission = "/permission",
  unassignedRequests = "/unassignedRequests",
  assignedRequests = "/assignedRequests",
  membershipRequest = "/membershipRequest",
  article = "/article",
  dysplasiaRequest = "/dysplasiaRequest",
  membershipRenewal = "/membershipRenewal",
  appealDysplasia = "/appealDysplasia",
  commissionDysplasia = "/commissionDysplasia",
  competitionRequest = "/competitionRequest",
  competition = "/competition",
  affixRequest = "/affixRequest",
  affixExport = "/affixExport",
  affixImport = "/affixImport",
  healthPack = "/healthPack",
  healthTestRequest = "/healthTestRequest",
  broodRequest = "/broodRequest",
  email = "/email",
  miscellaneousRequest = "/miscellaneousRequest",
  gentCommission = "/gentCommission",
  personSplit = "/personSplit",
  personFusion = "/personFusion",
  dogFusion = "/dogFusion",
  documentTemplate = "/documentTemplate",
  mailAdmin = "/mailAdmin",
  changePassword = "/changePassword",
  reprintPedigree = "/reprintPedigree",
  report = "/report",
  expatriationRequest = "/expatriationRequest",
  language = "/language",
}
